import axios from 'axios';
import storage from '../utils/storage';
import getConfig from '../config';

export const clientApi = (multi) => {
  const getToken = storage.get('token');

  const header = getToken ? {
    Authorization: `Bearer ${getToken}`,
  } : {};
  const { backendApi } = getConfig();
  const api = axios.create({
    baseURL: backendApi,
    headers: {
      ...header,
      'Content-Type': multi ? 'multipart/form-data' : 'application/json',
    },
  });

  return api;
};
